import {twMerge} from '@sdox/utils'
import {IconConfigurator} from '@sdox/icons/large'

import {LazyImage} from '../../LazyImage'

import type {LazyImageProps} from '../../LazyImage'
import type {FolderItemType} from '../types'

export interface MediaPartProps {
  imageProps?: LazyImageProps
  type: FolderItemType
}

export const MediaPart = ({
  type,
  imageProps,
}: MediaPartProps) => {
  const {className, ...restProps} = imageProps ?? {}
  if (type === 'catalog') {
    return (
      <LazyImage
        className={twMerge(
          'aspect-[16/10] w-full object-cover object-center',
          className,
        )}
        {...restProps}
      />
    )
  }

  if (type === 'configurator') {
    return (
      <div className={'flex aspect-[16/10] w-full items-center justify-center bg-interactive-surface-filled-tile-secondary'}>
        <IconConfigurator className={'size-spacing-80 opacity-40'} />
      </div>
    )
  }

  if (type === 'media') {
    return (
      <div className={'w-full bg-interactive-surface-filled-tile-secondary px-spacing-16 pt-spacing-16'}>
        <LazyImage
          className={twMerge(
            'block aspect-[16/10] w-full rounded-t-radius-lg object-cover object-top',
            className,
          )}
          {...restProps}
        />
      </div>
    )
  }

  const _exhaustiveCheck: never = type
  return null
}
